export enum BlendingDstFactorName {
  ConstantAlphaFactor = 'ConstantAlphaFactor',
  ConstantColorFactor = 'ConstantColorFactor',
  DstAlphaFactor = 'DstAlphaFactor',
  DstColorFactor = 'DstColorFactor',
  OneFactor = 'OneFactor',
  OneMinusConstantAlphaFactor = 'OneMinusConstantAlphaFactor',
  OneMinusConstantColorFactor = 'OneMinusConstantColorFactor',
  OneMinusDstAlphaFactor = 'OneMinusDstAlphaFactor',
  OneMinusDstColorFactor = 'OneMinusDstColorFactor',
  OneMinusSrcAlphaFactor = 'OneMinusSrcAlphaFactor',
  OneMinusSrcColorFactor = 'OneMinusSrcColorFactor',
  SrcAlphaFactor = 'SrcAlphaFactor',
  SrcColorFactor = 'SrcColorFactor',
  ZeroFactor = 'ZeroFactor'
}
